import { fromInteger, op_LeftShift, op_Addition, op_RightShift, op_BitwiseAnd, toInt, fromBits, equals } from "../fable-library.3.7.20/Long.js";
import { equalsWith } from "../fable-library.3.7.20/Array.js";
import { equals as equals_1 } from "../fable-library.3.7.20/Util.js";
import { op_Addition as op_Addition_1, op_Subtraction, op_Division, op_Multiply, fromParts, equals as equals_2 } from "../fable-library.3.7.20/Decimal.js";
import { Memo_create } from "./Memo.fs.js";
import { printf, toFail } from "../fable-library.3.7.20/String.js";
import { class_type } from "../fable-library.3.7.20/Reflection.js";

export function MarkModule_fold(f, seed, m, data) {
    const f$0027 = f;
    let i;
    const m_1 = m;
    i = (equals(m_1, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_1, fromBits(4294967295, 0, false))))));
    let len;
    const m_2 = m;
    len = (equals(m_2, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_2, 32)))));
    let acc = seed;
    while (len > 0) {
        acc = f$0027(acc, data(i));
        i = ((i + 1) | 0);
        len = ((len - 1) | 0);
    }
    return acc;
}

export function MarkModule_foldWhile(f, seed, m, data) {
    const f$0027 = f;
    let i;
    const m_1 = m;
    i = (equals(m_1, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_1, fromBits(4294967295, 0, false))))));
    let len;
    const m_2 = m;
    len = (equals(m_2, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_2, 32)))));
    let acc = seed;
    let doContinue = true;
    while (doContinue && (len > 0)) {
        const patternInput = f$0027(acc, data(i));
        doContinue = patternInput[1];
        acc = patternInput[0];
        i = ((i + 1) | 0);
        len = ((len - 1) | 0);
    }
    return acc;
}

export function MarkModule_splitBy$0027(f, seed, target, source, m) {
    let m_2;
    let mStart;
    const m_1 = m;
    mStart = (equals(m_1, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_1, fromBits(4294967295, 0, false))))));
    const mEnd = ((mStart + ((m_2 = m, equals(m_2, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_2, 32))))))) - 1) | 0;
    if ((!equalsWith(equals_1, target, null)) && (target.length === 1)) {
        const c = target[0];
        const splitByByte$0027 = (start_mut, acc_mut, i1_mut, i2_mut) => {
            let pos_1;
            splitByByte$0027:
            while (true) {
                const start = start_mut, acc = acc_mut, i1 = i1_mut, i2 = i2_mut;
                if (i1 < start) {
                    return f(acc, op_Addition(op_LeftShift(fromInteger((i2 - start) + 1, false, 2), 32), fromInteger(start, false, 2)));
                }
                else if (equals_1(source(i1), c)) {
                    start_mut = start;
                    acc_mut = f(acc, (pos_1 = ((i1 + 1) | 0), op_Addition(op_LeftShift(fromInteger(i2 - i1, false, 2), 32), fromInteger(pos_1, false, 2))));
                    i1_mut = (i1 - 1);
                    i2_mut = (i1 - 1);
                    continue splitByByte$0027;
                }
                else {
                    start_mut = start;
                    acc_mut = acc;
                    i1_mut = (i1 - 1);
                    i2_mut = i2;
                    continue splitByByte$0027;
                }
                break;
            }
        };
        return splitByByte$0027(mStart, seed, mEnd, mEnd);
    }
    else {
        const c_1 = target;
        const isTarget = (targetLen_mut, si_mut, i_mut) => {
            isTarget:
            while (true) {
                const targetLen = targetLen_mut, si = si_mut, i = i_mut;
                if (i === targetLen) {
                    return true;
                }
                else if (si > mEnd) {
                    return false;
                }
                else if (equals_1(source(si), c_1[i])) {
                    targetLen_mut = targetLen;
                    si_mut = (si + 1);
                    i_mut = (i + 1);
                    continue isTarget;
                }
                else {
                    return false;
                }
                break;
            }
        };
        const splitBy$0027 = (targetLen_1_mut, start_1_mut, acc_1_mut, i1_1_mut, i2_1_mut) => {
            let pos_3;
            splitBy$0027:
            while (true) {
                const targetLen_1 = targetLen_1_mut, start_1 = start_1_mut, acc_1 = acc_1_mut, i1_1 = i1_1_mut, i2_1 = i2_1_mut;
                if (i1_1 < start_1) {
                    return f(acc_1, op_Addition(op_LeftShift(fromInteger((i2_1 - start_1) + 1, false, 2), 32), fromInteger(start_1, false, 2)));
                }
                else if (isTarget(targetLen_1, i1_1, 0)) {
                    targetLen_1_mut = targetLen_1;
                    start_1_mut = start_1;
                    acc_1_mut = f(acc_1, (pos_3 = ((i1_1 + targetLen_1) | 0), op_Addition(op_LeftShift(fromInteger(((i2_1 - i1_1) - targetLen_1) + 1, false, 2), 32), fromInteger(pos_3, false, 2))));
                    i1_1_mut = (i1_1 - 1);
                    i2_1_mut = (i1_1 - 1);
                    continue splitBy$0027;
                }
                else {
                    targetLen_1_mut = targetLen_1;
                    start_1_mut = start_1;
                    acc_1_mut = acc_1;
                    i1_1_mut = (i1_1 - 1);
                    i2_1_mut = i2_1;
                    continue splitBy$0027;
                }
                break;
            }
        };
        return splitBy$0027(c_1.length, mStart, seed, mEnd, mEnd);
    }
}

export function MarkModule_trimStart$0027(predicate, m) {
    let m_2, m_4;
    if (((m_2 = m, equals(m_2, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_2, 32)))))) === 0) {
        return m;
    }
    else {
        let i;
        const m_3 = m;
        i = (equals(m_3, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_3, fromBits(4294967295, 0, false))))));
        const endAt = ((i + ((m_4 = m, equals(m_4, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_4, 32))))))) - 1) | 0;
        while ((i <= endAt) && predicate(i)) {
            i = ((i + 1) | 0);
        }
        if (i > endAt) {
            const pos = i | 0;
            return op_Addition(op_LeftShift(fromInteger(0, false, 2), 32), fromInteger(pos, false, 2));
        }
        else {
            const pos_1 = i | 0;
            return op_Addition(op_LeftShift(fromInteger((endAt - i) + 1, false, 2), 32), fromInteger(pos_1, false, 2));
        }
    }
}

export function MarkModule_trimEnd$0027(predicate, m) {
    let m_2, m_4;
    if (((m_2 = m, equals(m_2, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_2, 32)))))) === 0) {
        return m;
    }
    else {
        let endAt;
        const m_3 = m;
        endAt = (equals(m_3, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_3, fromBits(4294967295, 0, false))))));
        let i = (endAt + ((m_4 = m, equals(m_4, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_4, 32))))))) - 1;
        while ((i >= endAt) && predicate(i)) {
            i = ((i - 1) | 0);
        }
        if (i < endAt) {
            return op_Addition(op_LeftShift(fromInteger(0, false, 2), 32), fromInteger(endAt, false, 2));
        }
        else {
            return op_Addition(op_LeftShift(fromInteger((i - endAt) + 1, false, 2), 32), fromInteger(endAt, false, 2));
        }
    }
}

export function MarkModule_trim$0027(predicate, m) {
    return MarkModule_trimStart$0027(predicate, MarkModule_trimEnd$0027(predicate, m));
}

export function MarkModule_equals$0027(target, m, buf) {
    let m_1;
    if (target.length === ((m_1 = m, equals(m_1, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_1, 32))))))) {
        let i = 0;
        return MarkModule_foldWhile((same, b) => {
            const r = same && (b === target[i]);
            i = ((i + 1) | 0);
            return [r, r];
        }, true, m, (i_1) => buf[i_1]);
    }
    else {
        return false;
    }
}

export const MarkModule_Numeric_precisionTable = (() => {
    const precisionTable$0027 = (n) => {
        if (equals_2(n, fromParts(1, 0, 0, false, 0))) {
            return fromParts(1, 0, 0, false, 0);
        }
        else {
            return op_Multiply(fromParts(1, 0, 0, false, 1), precisionTable$0027(op_Division(n, fromParts(10, 0, 0, false, 0))));
        }
    };
    return Memo_create(precisionTable$0027);
})();

export function MarkModule_Numeric_toDecimal$0027(zeroChar, zero, one, ten, toTarget, m, ctx) {
    let m_2, b$0027;
    let p;
    const m_1 = m;
    p = (equals(m_1, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_1, fromBits(4294967295, 0, false))))));
    let i = (p + ((m_2 = m, equals(m_2, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_2, 32))))))) - 1;
    let d = zero;
    let mul = one;
    while (i >= p) {
        const matchValue = ctx[i];
        let pattern_matching_result;
        if ((b$0027 = matchValue, (b$0027 >= 48) && (b$0027 <= 57))) {
            pattern_matching_result = 0;
        }
        else if (matchValue === 44) {
            pattern_matching_result = 1;
        }
        else if (matchValue === 46) {
            pattern_matching_result = 1;
        }
        else {
            pattern_matching_result = 2;
        }
        switch (pattern_matching_result) {
            case 0: {
                const b = op_Subtraction(toTarget(matchValue), zeroChar);
                d = op_Addition_1(d, op_Multiply(mul, b));
                mul = op_Multiply(mul, ten);
                i = ((i - 1) | 0);
                break;
            }
            case 1: {
                d = op_Multiply(d, MarkModule_Numeric_precisionTable(mul));
                mul = one;
                i = ((i - 1) | 0);
                break;
            }
            case 2: {
                toFail(printf("%d is not a digit or dot"))(matchValue);
                break;
            }
        }
    }
    return d;
}

export class Slice$1 {
    constructor(m, d) {
        this.m = m;
        this.d = d;
    }
}

export function Slice$1$reflection(gen0) {
    return class_type("Svea.Dry.Slice`1", [gen0], Slice$1);
}

export function Slice$1_$ctor_6EF4186C(m, d) {
    return new Slice$1(m, d);
}

export function Slice$1__get_Mark(x) {
    return x.m;
}

export function Slice$1__get_Data(x) {
    return x.d;
}

export function Slice$1_$ctor_B867673(d) {
    return Slice$1_$ctor_6EF4186C(op_Addition(op_LeftShift(fromInteger(d.length, false, 2), 32), fromInteger(0, false, 2)), d);
}

export function Slice_ofSlice(m, s) {
    let pos, m_1, m_2, m_3;
    return Slice$1_$ctor_6EF4186C((pos = ((((m_1 = m, equals(m_1, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_1, fromBits(4294967295, 0, false))))))) + ((m_2 = Slice$1__get_Mark(s), equals(m_2, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_BitwiseAnd(m_2, fromBits(4294967295, 0, false)))))))) | 0), op_Addition(op_LeftShift(fromInteger((m_3 = m, equals(m_3, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_3, 32))))), false, 2), 32), fromInteger(pos, false, 2))), Slice$1__get_Data(s));
}

export function Slice_isEmpty(s) {
    let m_1;
    return ((m_1 = Slice$1__get_Mark(s), equals(m_1, fromBits(4294967295, 4294967295, false)) ? -1 : (~(~toInt(op_RightShift(m_1, 32)))))) === 0;
}

export function Slice_ofArray(m, d) {
    return Slice$1_$ctor_6EF4186C(m, d);
}

export function Slice_ofFullArray(d) {
    return Slice$1_$ctor_B867673(d);
}

export function Slice_fold(f, seed, slice) {
    return MarkModule_fold(f, seed, Slice$1__get_Mark(slice), (i) => Slice$1__get_Data(slice)[i]);
}

export function Slice_foldWhile(f, seed, slice) {
    return MarkModule_foldWhile(f, seed, Slice$1__get_Mark(slice), (i) => Slice$1__get_Data(slice)[i]);
}

